module.exports = __webpack_public_path__ + "static/media/3d-product-img.c862d446.svg";